import { render, staticRenderFns } from "./ChartSupplierStadistics.vue?vue&type=template&id=b3373af2&scoped=true&"
import script from "./ChartSupplierStadistics.vue?vue&type=script&lang=js&"
export * from "./ChartSupplierStadistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3373af2",
  null
  
)

export default component.exports